var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21_9859)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.66665 1.83325C4.44499 1.83325 1.83331 4.44492 1.83331 7.66659C1.83331 10.8882 4.44499 13.4999 7.66665 13.4999C10.8883 13.4999 13.5 10.8882 13.5 7.66659C13.5 4.44492 10.8883 1.83325 7.66665 1.83325ZM0.833313 7.66659C0.833313 3.89264 3.8927 0.833252 7.66665 0.833252C11.4406 0.833252 14.5 3.89264 14.5 7.66659C14.5 9.37359 13.8741 10.9344 12.8392 12.1321L15.0202 14.313C15.2155 14.5083 15.2155 14.8249 15.0202 15.0201C14.8249 15.2154 14.5084 15.2154 14.3131 15.0201L12.1321 12.8392C10.9345 13.874 9.37366 14.4999 7.66665 14.4999C3.8927 14.4999 0.833313 11.4405 0.833313 7.66659Z",
    fill: "#0D0D0D",
    fillOpacity: 0.4
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21_9859"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.a01ea8acc0f029bcaae525eb48e35946.svg";
export { ForwardRef as ReactComponent };